window.$ = window.jQuery = require("jquery");
require("jquery-validation");
require("jquery-validation/dist/additional-methods.min");

require("./components/footer");
require("./components/inputNumber");
require("./components/quoteBlock");
require("./components/quoteTable");
require("./components/togglePromo");
require("./components/navToggle");
require("./components/modal");
require("./components/datePicker");
require("./components/dobHandler");
require("./components/aside");
require("./components/formDupe");
require("./components/consolidatedQuestions");

require("./utils/applyDiscount");
require("./utils/addOrRemoveRows");
require("./utils/validation/validation");
require("./utils/setHyperlinkTargetToBlank");
require("./utils/toggleExtraDetails");
require("./utils/matchHeights");
